export enum IInboxMessageType {
  TEXT = "text",
  VIDEO = "video",
  IMAGE = "image",
  AUDIO = "audio",
  DOCUMENT = "document",
  LOCATION = "location",
}
